export const REGISTRATIONS_PERMISSIONS = {
	createClients: 'registrations.createClients',
	editClients: 'registrations.editClients',
} as const;

export type TRegistrationsPermission =
	typeof REGISTRATIONS_PERMISSIONS[keyof typeof REGISTRATIONS_PERMISSIONS];
